const BurgerMenuIcon = () => {
  return (
    <svg viewBox="0 0 18 5.72">
      <path
        d="M63.772,221.05a.817.817,0,1,0,0,1.634H80.115a.817.817,0,1,0,0-1.634Zm0,4.086a.817.817,0,1,0,0,1.634H80.115a.817.817,0,1,0,0-1.634Z"
        transform="translate(-62.943 -221.05)"
        fill="#e2e2e2"
      />
    </svg>
  );
};

export default BurgerMenuIcon;
